export default __webpack_public_path__ + "static/media/landingBg1.4cc96ec8.jpg";